// airdatepicker.js
import AirDatepicker from 'air-datepicker'
import localeUk from 'air-datepicker/locale/uk'
import 'air-datepicker/air-datepicker.css'

const pickers = document.querySelectorAll('.js-air-datepicker')
const pickersArray = []
const multipleDatesSeparator = ' - '

Array.from(pickers).forEach(picker => {
    const range = picker.dataset.range == 'true'
    const newPicker = new AirDatepicker(picker, {
        locale: localeUk,
        position: picker.dataset.position,
        range,
        multipleDatesSeparator,
        buttons: 'clear',
        onSelect({ formattedDate }) {
            console.log(formattedDate)
            //picker.setAttribute('value', formattedDate.join(" - "))
            const emitIndex = picker.dataset.liveEmitIndex // data-live-emit-index
            if (picker.dataset.livewire_name && picker.dataset.livewire_attribute) {
                let livewireName = picker.dataset.livewire_name
                let livewireAttribute = picker.dataset.livewire_attribute

                window.livewire.emit(  emitIndex ? 'setDataPicker' + emitIndex : 'setDataPicker', 
                    {livewire : livewireName, livewireAttribute : formattedDate})

                // if (emitIndex) {

                // } else {
                //     window.livewire.emit('setDataPicker', {livewire : livewireName, livewireAttribute : formattedDate});
                // }
                // console.log('setDataPicker')
            }
        }
    })


    pickersArray.push(newPicker)
})

CNS.$fns.reinitDatePicker = function(pickerSelector) {
    const picker = document.querySelector(pickerSelector)
    if (!picker) { return }
    const range = picker.dataset.range == 'true'

    const oldPicker = pickersArray.filter(p => {
        return p.$el.classList.contains(pickerSelector.slice(1))
    })[0]

    if (oldPicker) {
        oldPicker.update({
            locale: localeUk,
            position: picker.dataset.position,
            range,
            multipleDatesSeparator,
            buttons: 'clear',
            onSelect({ formattedDate }) {
                picker.setAttribute('value', formattedDate.join(" - "))
                console.log(picker.dataset)
                const emitIndex = picker.dataset.liveEmitIndex // data-live-emit-index
                if (picker.dataset.livewire_name && picker.dataset.livewire_attribute) {
                    let livewireName = picker.dataset.livewire_name
                    let livewireAttribute = picker.dataset.livewire_attribute

                    window.livewire.emit(  emitIndex ? 'setDataPicker' + emitIndex : 'setDataPicker', 
                        {livewire : livewireName, livewireAttribute : formattedDate})
                    //window.livewire.emit('setDataPicker', {livewire : livewireName, livewireAttribute : formattedDate.join(" - ")});
                    // console.log('setDataPicker')
                }
            }
        })

    } else {
        const newPicker = new AirDatepicker(picker, {
            locale: localeUk,
            position: picker.dataset.position,
            range,
            multipleDatesSeparator,
            buttons: 'clear',
            onSelect({ formattedDate }) {
                picker.setAttribute('value', formattedDate.join(" - "))
                console.log(picker.dataset)
                const emitIndex = picker.dataset.liveEmitIndex // data-live-emit-index=""
                if (picker.dataset.livewire_name && picker.dataset.livewire_attribute) {
                    let livewireName = picker.dataset.livewire_name
                    let livewireAttribute = picker.dataset.livewire_attribute

                    window.livewire.emit(  emitIndex ? 'setDataPicker' + emitIndex : 'setDataPicker', 
                        {livewire : livewireName, livewireAttribute : formattedDate})
                    //window.livewire.emit('setDataPicker', {livewire : livewireName, livewireAttribute : formattedDate.join(" - ")});
                    // console.log('setDataPicker')
                }
            }
        })

        pickersArray.push(newPicker)
    }
}


document.querySelectorAll('.js-datepicker-hide-on-scroll-listener').forEach(listener => {
    let scrollTimer = null
    listener.addEventListener('scroll', () => {
        clearTimeout(scrollTimer)
        scrollTimer = setTimeout(() => {
            pickersArray.forEach(p => {
                try {
                    p.hide()
                } catch (e) {}
            })
        }, 100)
    })
})
